import React, { useEffect, useState } from "react";
import "../styles/partnerStyles.css";
import { useLocation, useNavigate } from "react-router";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { partnerData } from "../data/partner";
import { Row, Col } from "react-bootstrap";
import salesIcon from "../assets/icons/sales.png";
import supportIcon from "../assets/icons/support.png";
import visitIcon from "../assets/icons/location.png";
import whatsappIcon from "../assets/icons/connect.png";
import { Country, State, City } from "country-state-city";
import Select from "react-select";

const Partner = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    landline: "",
    address: "",
    pincode: "",
    state: "",
    country: "India",
    companyName: "",
    dateOfEstablishment: "",
    experience: "",
    annualTurnover: "",
    products: "",
    salesTeam: "",
    fieldStaff: "",
    technicalStaff: "",
    gstCertificate: null,
    panCard: null,
  });
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  useEffect(() => {
    console.log(selectedCountry);
    console.log(selectedCountry?.isoCode);
    console.log(State?.getStatesOfCountry(selectedCountry?.isoCode));
  }, [selectedCountry]);

  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const salesEmail = isUAEPath
    ? "ceo@timewatchuae.com"
    : "sales@timewatchindia.com";
  const salesText = isUAEPath
    ? "Connect With Our Team"
    : "Connect With Sales Team";
  const subsalestext = isUAEPath
    ? "Looking For Solutions? Talk to Us!"
    : "Looking For Solutions? Talk to Sales!";

  const phone = isUAEPath ? "+971-54-777-0637" : "+91-95999 53923";

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    setLoading(true);

    try {
      const response = await fetch(
        "https://api.mytimewatch.com/api/partner/submit",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      if (response.ok) {
        setIsSubmitting(false);
        navigate("/thank-you");
      } else {
        navigate("/error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error submitting the form");
    } finally {
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        mobile: "",
        landline: "",
        address: "",
        pincode: "",
        state: "",
        country: "",
        companyName: "",
        dateOfEstablishment: "",
        experience: "",
        annualTurnover: "",
        products: "",
        salesTeam: "",
        fieldStaff: "",
        technicalStaff: "",
        gstCertificate: null,
        panCard: null,
      });
    }
  };

  return (
    <>
      <div
        className="p-5 text-center bg-image"
        style={{
          backgroundImage:
            "url('https://timewatch.co.in/images/partner-banner.png')",
          height: 700,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className=" text-center">
          <h1 className="mb-3 fw-bold fs-1" style={{ color: "#DA1F26" }}>
            Partner with Us and Grow Together
          </h1>
          <h4 className="mb-3 fw-bold text-black">
            Join our network of innovators and industry leaders.
          </h4>
          <button
            className="btn btn-lg fw-bold"
            onClick={() =>
              document
                .getElementById("jobApplicationForm")
                .scrollIntoView({ behavior: "smooth" })
            }
            role="button"
            style={{
              backgroundColor: "#ffffff",
              color: "#DA1F26",
              textDecoration: "none",
              border: "2px solid #DA1F26",
              borderRadius: "50px",
            }}
          >
            Become a Partner
          </button>
        </div>
      </div>
      <div className="partner-container">
        <div className="container mt-5 text-center">
          <h2 className="mb-5 fw-bold text-black">
            Why Choose Us as Your Partner?
          </h2>
          <div className="row justify-content-center">
            {partnerData.map((partnerData, index) => (
              <div
                key={index}
                className="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
              >
                <img
                  src={require(`../assets/icons/${partnerData.icon}`)}
                  alt={partnerData.alt}
                  className="mb-3 img-fluid"
                  style={{ maxWidth: "100px", height: "auto" }}
                />
                <h4 className="text-black fw-bold mb-2">
                  {partnerData.heading}
                </h4>
                <p
                  className="fst-italic text-secondary"
                  style={{ fontSize: "14px" }}
                >
                  {partnerData.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div>
        <h1 className="fw-bold text-black text-center">How it works?</h1>

        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Step 1"
            icon={
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "30px",
                  fontFamily: "Inria Serif",
                }}
              >
                1
              </div>
            }
            iconStyle={{
              background: "#0053ED",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h3
              className="vertical-timeline-element-title fw-bold"
              style={{ color: "#F14144" }}
            >
              Apply Now
            </h3>
            <p>Fill out the form below to express your interest.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Step 2"
            icon={
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "30px",
                  fontFamily: "Inria Serif",
                }}
              >
                2
              </div>
            }
            iconStyle={{
              background: "#0053ED",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h3
              className="vertical-timeline-element-title fw-bold"
              style={{ color: "#F14144" }}
            >
              Connect
            </h3>
            <p>We’ll reach out for a discovery session.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Step 3"
            icon={
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "30px",
                  fontFamily: "Inria Serif",
                }}
              >
                3
              </div>
            }
            iconStyle={{
              background: "#0053ED",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h3
              className="vertical-timeline-element-title fw-bold"
              style={{ color: "#F14144" }}
            >
              Collaborate
            </h3>
            <p>Define roles and start our partnership journey.</p>
          </VerticalTimelineElement>

          <VerticalTimelineElement
            id="jobApplicationForm"
            className="vertical-timeline-element--work"
            date="Step 4"
            icon={
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "30px",
                  fontFamily: "Inria Serif",
                }}
              >
                4
              </div>
            }
            iconStyle={{
              background: "#0053ED",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h3
              className="vertical-timeline-element-title fw-bold"
              style={{ color: "#F14144" }}
            >
              Grow Together
            </h3>
            <p>Unlock growth and success together.</p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>

      <div className="partner-container">
        <div className="partner-content">
          <h1 className="fw-bold text-black">Let's Get Started!</h1>
          <div className="container mx-auto px-4 md:px-6"></div>
          <form onSubmit={handleSubmit} className="partner-form">
            <div className="form-row">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="e.g., John Doe"
              />
            </div>
            <div className="form-row">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="e.g., john@mail.com"
              />
            </div>
            <div className="form-row">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                required
                placeholder="e.g., 90875632817"
              />
            </div>
            <div className="form-row">
              <label>Landline</label>
              <input
                type="tel"
                name="landline"
                value={formData.landline}
                onChange={handleChange}
                placeholder="e.g., 1100 7456"
              />
            </div>
            <div className="form-row">
              <label>Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                placeholder="e.g., ABC Street"
              />
            </div>
            <div className="form-row">
              <label>Pincode</label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                required
                placeholder="e.g., 110034"
              />
            </div>
            <div className="form-row">
              <label>Country</label>
              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder="Enter Country"
                required
              />
            </div>
            <div className="form-row">
              <label>State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter State"
                required
              />
            </div>

            <div className="form-row">
              <label>Company Name</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                required
                placeholder="e.g., XYZ Pvt. Ltd."
              />
            </div>
            <div className="form-row">
              <label>Date of Establishment</label>
              <input
                type="date"
                name="dateOfEstablishment"
                value={formData.dateOfEstablishment}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-row">
              <label>Experience in Business Line</label>
              <select
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="0-2">0-2 years</option>
                <option value="3-5">3-5 years</option>
                <option value="6-10">6-10 years</option>
                <option value="10+">10+ years</option>
              </select>
            </div>
            <div className="form-row">
              <label>Annual Turnover</label>
              <select
                name="annualTurnover"
                value={formData.annualTurnover}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="0-10">0-50 Lakh</option>
                <option value="10-50">50 Lakh - 1 Cr</option>
                <option value="1+">1 Cr+</option>
              </select>
            </div>
            <div className="form-row">
              <label>Products You Are Dealing In</label>
              <select
                name="products"
                value={formData.products}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="timeattendance">Time & Attendance</option>
                <option value="Access Control">Access Control</option>
                <option value="Entrance Control">Entrance Control</option>
                <option value="Parking and Traffic Control">
                  Parking & Traffic Control
                </option>
                <option value="Inspection Control">Inspection Control</option>
                <option value="UL Listed EM Locks">
                  UL Listed EM Locks & Accessories
                </option>
                <option value="Software and application">
                  Software & Applications
                </option>
              </select>
            </div>
            <div className="form-row">
              <label>Number of Sales Team</label>
              <select
                name="salesTeam"
                value={formData.salesTeam}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="0-50">0-50</option>
                <option value="50-100">50-100</option>
                <option value="100-200">100-200</option>
                <option value="200+">200+</option>
              </select>
            </div>
            <div className="form-row">
              <label>Number of Field Staff</label>
              <select
                name="fieldStaff"
                value={formData.fieldStaff}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="0-50">0-50</option>
                <option value="50-100">50-100</option>
                <option value="100-200">100-200</option>
                <option value="200+">200+</option>
              </select>
            </div>
            <div className="form-row">
              <label>Number of Technical Staff</label>
              <select
                name="technicalStaff"
                value={formData.technicalStaff}
                onChange={handleChange}
                required
              >
                <option value="">--Select Range--</option>
                <option value="0-50">0-50</option>
                <option value="50-100">50-100</option>
                <option value="100-200">100-200</option>
                <option value="200+">200+</option>
              </select>
            </div>
            <div className="form-row">
              <label>GST Certificate (PDF)</label>
              <input
                type="file"
                name="gstCertificate"
                accept=".pdf"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="form-row">
              <label>PAN Card (PDF)</label>
              <input
                type="file"
                name="panCard"
                accept=".pdf"
                onChange={handleFileChange}
                required
              />
            </div>
            <button
              type="submit"
              className="submit-button fw-bold"
              style={{
                backgroundColor: "#f14144",
                color: "white",
                textDecoration: "none",
                border: "2px solid #f14144",
                borderRadius: "50px",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Join As A Partner"}
            </button>
          </form>
        </div>
      </div>
      <div className="h-100 mt-5 d-flex align-items-center justify-content-center mb-5">
        <section className="contact-info-boxes container">
          <h1 className="fw-bold text-black">Have Questions?</h1>
          <Row className="justify-content-center g-4 text-center">
            {/* Card 1 */}
            <Col xs={12} sm={6} md={3}>
              <a
                href={`mailto:${salesEmail}`}
                className="text-decoration-none"
                style={{ color: "black" }}
              >
                <div
                  className="p-3 border rounded bg-white position-relative d-flex flex-column"
                  style={{ height: "180px" }}
                >
                  <img
                    src={salesIcon}
                    alt="Sales Icon"
                    className="position-absolute"
                    style={{ top: "10px", left: "10px", width: "35px" }}
                  />
                  <div className="text-start mt-5">
                    <h4 className="mb-1">{salesText}</h4>
                    <p className="mb-3 fw-bold" style={{ fontSize: "12px" }}>
                      {subsalestext}
                    </p>
                  </div>
                  <p
                    className="text-start mb-0 text-decoration-underline fw-bold"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                      fontSize: "15px",
                    }}
                  >
                    {salesEmail}
                  </p>
                </div>
              </a>
            </Col>

            {/* Card 2 */}
            {!isUAEPath && (
              <Col xs={12} sm={6} md={3}>
                <a
                  href={`mailto:support@timewatchindia.com`}
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div
                    className="p-3 border rounded bg-white position-relative d-flex flex-column"
                    style={{ height: "180px" }}
                  >
                    <img
                      src={supportIcon}
                      alt="Support Icon"
                      className="position-absolute"
                      style={{ top: "10px", left: "10px", width: "35px" }}
                    />
                    <div className="text-start mt-5">
                      <h4 className="mb-1">Connect With Support Team</h4>
                      <p className="mb-4 fw-bold" style={{ fontSize: "12px" }}>
                        Need Help? Reach Support!
                      </p>
                    </div>
                    <p
                      className="text-start mb-0 text-decoration-underline fw-bold"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        fontSize: "15px",
                      }}
                    >
                      support@timewatchindia.com
                    </p>
                  </div>
                </a>
              </Col>
            )}

            {/* Card 3 */}
            {!isUAEPath && (
              <Col xs={12} sm={6} md={3}>
                <a
                  href="https://maps.app.goo.gl/e27BDUXwoioQxPEB9"
                  className="text-decoration-none"
                  style={{ color: "black" }}
                >
                  <div
                    className="p-3 border rounded bg-white position-relative d-flex flex-column"
                    style={{ height: "180px" }}
                  >
                    <img
                      src={visitIcon}
                      alt="Visit Icon"
                      className="position-absolute"
                      style={{ top: "10px", left: "10px", width: "35px" }}
                    />
                    <div className="text-start mt-5">
                      <h4 className="mb-1">Visit Us</h4>
                      <p className="mb-4 fw-bold" style={{ fontSize: "12px" }}>
                        Want to Visit? Stop By!
                      </p>
                    </div>
                    <p
                      className="text-start mb-0 text-decoration-underline fw-bold"
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        fontSize: "15px",
                      }}
                    >
                      View On Google Maps
                    </p>
                  </div>
                </a>
              </Col>
            )}

            {/* Card 4 */}
            <Col xs={12} sm={6} md={3}>
              <a
                href={`tel:${phone}`}
                className="text-decoration-none"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <div
                  className="p-3 border rounded bg-white position-relative d-flex flex-column"
                  style={{ height: "180px" }}
                >
                  <img
                    src={whatsappIcon}
                    alt="WhatsApp Icon"
                    className="position-absolute"
                    style={{ top: "10px", left: "10px", width: "35px" }}
                  />
                  <div className="text-start mt-5">
                    <h4 className="mb-1">Connect With Us</h4>
                    <p className="mb-2 fw-bold" style={{ fontSize: "12px" }}>
                      Questions? Let’s Connect!
                    </p>
                  </div>
                  <p
                    className="text-start mb-0 text-decoration-underline fw-bold"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "10px",
                      fontSize: "15px",
                    }}
                  >
                    {phone}
                  </p>
                </div>
              </a>
            </Col>
          </Row>
        </section>
      </div>
    </>
  );
};

export default Partner;
